import { METHOD_TYPES } from "../../constants/common"
import { log } from "../../utils/common"
import { fetchDataAndProceedCampaign } from "../../utils/dataUtility"
import {
  UPDATE_CAMPAIGNS_ANALYTICS__STATE,
  UPDATE_LIVE_CAMPAIGNS__STATE,
  UPDATE_HISTORIC_CAMPAIGNS_STATE,
  UPDATE_COMPONENT_STATE,
  REMOVE_UPDATED_FLAG,
} from "./actiontypes"
import * as API from "./api"

export const updateCampaignAnalyticsState = payload => {
  return {
    type: UPDATE_CAMPAIGNS_ANALYTICS__STATE,
    payload,
  }
}

export const removeUpdatedFlag = id => ({
  type: REMOVE_UPDATED_FLAG,
  payload: { id },
})

export const fetchLiveMetrics = data => dispatch => {
  dispatch(
    updateCampaignAnalyticsState({ lLoadError: false })
  )
  fetchDataAndProceedCampaign(
    {
      url: API.fetchLiveMetrics,
      data,
      loader: false,
    },
    (err, res) => {
      log("fetchLiveMetrics response", err, res)
      if (!err && res && res.data && res.data.data) {
        dispatch(
          updateCampaignAnalyticsState({
            lLoadError: false,
          })
        )
        dispatch({
          type: UPDATE_LIVE_CAMPAIGNS__STATE,
          payload: res.data.data,
        })
      } else {
        dispatch(
          updateCampaignAnalyticsState({
            lLoadError: true,
          })
        )
      }
    }
  )
}

export const fetchMetrics = data => dispatch => {
  dispatch(updateCampaignAnalyticsState({ hLoadError: false, hLoading: true }))
  fetchDataAndProceedCampaign(
    {
      url: API.fetchMetrics,
      data,
      timeout: 30000,
    },
    (err, res) => {
      log("fetchMetrics response", err, res)
      if (!err && res && res.data && res.data.data) {
        dispatch(
          updateCampaignAnalyticsState({
            hLoadError: false,
            hLoading: false,
          })
        )
        dispatch({
          type: UPDATE_HISTORIC_CAMPAIGNS_STATE,
          payload: {
            data: res.data.data,
            apiType: "logsData",
          },
        })
      } else {
        dispatch(
          updateCampaignAnalyticsState({
            hLoadError: true,
            hLoading: false,
          })
        )
      }
    }
  )
}

export const fetchSessionData = data => dispatch => {
  dispatch(updateCampaignAnalyticsState({ sLoadError: false, sLoading: true }))
  fetchDataAndProceedCampaign(
    {
      url: API.fetchSessionData,
      data,
      timeout: 30000,
    },
    (err, res) => {
      log("fetchSessionData response", err, res)
      if (!err && res && res.data && res.data.data) {
        dispatch(
          updateCampaignAnalyticsState({
            sLoadError: false,
            sLoading: false,
          })
        )
        dispatch({
          type: UPDATE_HISTORIC_CAMPAIGNS_STATE,
          payload: {
            data: res.data.data,
            apiType: "sessionData",
          },
        })
      } else {
        dispatch(
          updateCampaignAnalyticsState({
            sLoadError: true,
            sLoading: false,
          })
        )
      }
    }
  )
}

export const fetchCampaignRecordsData = data => dispatch => {
  dispatch(updateCampaignAnalyticsState({ cLoadError: false, cLoading: true }))
  fetchDataAndProceedCampaign(
    {
      url: API.fetchCampaignRecordsData,
      data,
      timeout: 30000,
    },
    (err, res) => {
      log("fetchCampaignRecordsData response", err, res)
      if (!err && res && res.data && res.data.data) {
        dispatch(
          updateCampaignAnalyticsState({
            cLoadError: false,
            cLoading: false,
          })
        )
        dispatch({
          type: UPDATE_HISTORIC_CAMPAIGNS_STATE,
          payload: {
            data: res.data.data,
            apiType: "campaignsRecordsData",
          },
        })
      } else {
        dispatch(
          updateCampaignAnalyticsState({
            cLoadError: true,
            cLoading: false,
          })
        )
      }
    }
  )
}

// testing - pending from backend - loading state testing pending 
export const fetchGraphRefreshData = (data, callback) => dispatch => {
  dispatch(updateCampaignAnalyticsState({ loading: true, loadError: false }))
  fetchDataAndProceedCampaign(
    {
      url: API.fetchGraphRefreshData,
      data,
      method: METHOD_TYPES.POST,
      timeout: 30000,
    },
    (err, res) => {
      log("fetchGraphRefreshData response", err, res)
      if (!err && res && res.data && res.data.data) {
        dispatch(
          updateCampaignAnalyticsState({ loading: false, loadError: false })
        )
        dispatch({
          type: UPDATE_COMPONENT_STATE,
          payload: res.data.data,
        })
        if (callback) {
          callback()
        }
      } else {
        dispatch(
          updateCampaignAnalyticsState({ loading: false, loadError: true })
        )
      }
    }
  )
}
